// src/hooks/useStopMetrics.js

import { useRegion } from '../contexts/RegionContext';
import { usePolledResource } from './usePolledResource';

export function useStopMetrics(routeId, options = {}) {
  const { adapter } = useRegion();
  const { enabled = true, refetchInterval = null } = options;
  const active = enabled && Boolean(routeId);

  return usePolledResource(
    () => adapter.fetchStopMetrics(routeId),
    [routeId, active, refetchInterval, adapter],
    { enabled: active, refetchInterval, initialData: [] }
  );
}